module.exports = __webpack_public_path__ + "img/product-specification.a56b5f77.svg";